import { ChevronIcon as DsChevronIcon } from "@packages/ds";
import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Wrapper = styled.div`
  width: 316px;
  margin-bottom: 16px;
  .dropdown {
    display: block;
    margin-bottom: 0;
    .input-wrapper {
      flex-direction: column;
      margin-bottom: 16px !important;
      align-items: flex-start;
    }

    .Select-menu-outer {
      .Select-option {
        padding-left: 2em;
      }
      .Select-option.is-disabled {
        cursor: default;
        padding-left: 1em;
        font-size: 12px;
        text-transform: uppercase;
      }
    }
  }
  .description {
    display: flex;
    align-items: center;
    .info-dialog {
      margin: 0 12px 0 0;
    }
  }
`;

export const Container = styled.div`
  position: relative;
`;

export const InputWrapper = styled.div`
  border-color: var(--input-transparent-border-color, var(--transparent));
  background-color: var(--input-ice-background-color, var(--ice));
  border-radius: 2px;
  min-height: 40px;
  transition:
    background-color,
    border-color 250;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px 0 16px;
  margin: 8px 0 12px;
`;

export const Input = styled.input`
  all: unset;
  width: 100%;
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var(--menu-ebony-light-color, var(--ebony-light));
  &::placeholder {
    color: var(--section-granite-color, var(--granite));
  }
  cursor: default;
`;

export const ContentWrapper = styled.div`
  box-sizing: border-box;
  position: absolute;
  display: flex;
  z-index: 9999;
  border: none;
  margin-top: 4px;
  padding: 8px;
  font-family: "Open Sans";
  width: 624px;
  border-radius: 2px;
  background-color: var(--menu-snow-background-color, var(--snow));
  box-shadow: ${`var(--box-shadow) ${"var(--menu-ebony-shadow-box-shadow-color,var(--ebony-shadow))"}`};
  @media only screen and (max-width: ${breakpoints[3]}) {
    width: 100%;
  }
`;

export const ItemList = styled.div`
  width: 50%;
  max-height: 300px;
  overflow-y: auto;
  @media only screen and (max-width: ${breakpoints[3]}) {
    width: 100%;
  }
`;

export const Header = styled.span`
  display: block;
  padding: 20px 16px 8px;
  color: var(--section-granite-color, var(--granite));
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-transform: uppercase;
`;

export const Item = styled.div<{ $isSelected: boolean }>`
  position: relative;
  display: block;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  border: 1px solid transparent;
  text-align: left;
  outline: none;
  border-radius: 4px;
  transition: 0.25s;
  cursor: pointer;
  color: ${props =>
    props.$isSelected
      ? "var(--menu-color-primary-600-color,var(--color-primary-600))"
      : "var(--menu-ebony-light-color,var(--ebony-light))"};
  background-color: ${props =>
    props.$isSelected
      ? "var(--section-color-primary-100-background-color,var(--color-primary-100))"
      : "none"};
  &:hover,
  &:focus {
    background-color: ${"var(--section-color-primary-100-background-color,var(--color-primary-100))"};
    color: var(--menu-color-primary-600-color, var(--color-primary-600));
  }
`;

export const ItemDetails = styled.div`
  width: 50%;
  min-height: 100%;
  padding: 16px;
  margin-left: 8px;
  border-radius: 4px;
  background-color: var(--input-ice-background-color, var(--ice));
  @media only screen and (max-width: ${breakpoints[3]}) {
    visibility: hidden;
    display: none;
  }
`;

export const LeafIconWrapper = styled.div`
  display: inline;
  vertical-align: sub;
`;

export const ChevronIcon = styled(DsChevronIcon)<{ isOpen: boolean }>`
  fill: ${props =>
    props.isOpen
      ? "var(--icon-color-primary-600-fill,var(--color-primary-600))"
      : "var(--icon-granite-fill,var(--granite))"};
  transform: ${props => (props.isOpen ? "rotate(180deg)" : undefined)};
`;

export const NoOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--section-granite-color, var(--granite));
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
